import { render, staticRenderFns } from "./ClientCDP.vue?vue&type=template&id=45ccd920"
import script from "./ClientCDP.vue?vue&type=script&lang=js"
export * from "./ClientCDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports